import "antd/dist/antd.min.css";
import "antd-button-color/dist/css/style.css";

import axios from "axios";
import React, { useEffect, useState } from "react";

import swal from "sweetalert";

import {
  Row,
  Col,
  Button,
  Form,
  Table,
  Layout,
  Typography,
  Divider,
  Input,
  Space,
  Modal,
  Descriptions,
  Card,
  Select,
  Badge,
  BackTop,
  Tabs,
  Tag,
  PageHeader,
  Carousel,
  ConfigProvider
} from "antd";

import {
  PaperClipOutlined,
  CheckOutlined,
  PlusOutlined,
  FileExcelOutlined
} from "@ant-design/icons";

import moment from "moment";
import "moment/locale/th";

import { createGlobalStyle } from "styled-components";

import dayjs from "dayjs";
import buddhistEra from "dayjs/plugin/buddhistEra";
import "dayjs/locale/th";
import thTH from "antd/lib/locale/th_TH";
import dayjsGenerateConfig from "rc-picker/lib/generate/dayjs";
import generatePicker from "antd/es/date-picker/generatePicker";

import Header_title_c from "../controls/Header_title_c";
import Footer_last from "../controls/Footer_last";

import * as xlsx from "xlsx";

const { Content } = Layout;
const { Text } = Typography;

const StyledForm = createGlobalStyle`.ant-form-item {
    margin-bottom: 5px;
  }
  `;

const layout1 = {
  labelCol: { span: 3 },
  wrapperCol: { span: 21 }
};

const Research_coordinator_list = () => {
  let xURL = "";
  let xlocation = window.location.hostname;

  if (xlocation === "localhost") {
    xURL = "http://localhost:3002/api/";
  } else {
    xURL = "https://research.rihes.cmu.ac.th/api/";
  }

  const [dataSource1, _dataSource1] = useState();
  const [dataSource2, _dataSource2] = useState();
  const [dataSource3, _dataSource3] = useState();

  const [dataSourceEx1, _dataSourceEx1] = useState();
  const [dataSourceEx2, _dataSourceEx2] = useState();

  const [dataContract, _dataContract] = useState();
  const [dataExpenses, _dataExpenses] = useState();
  const [dataExpenses2, _dataExpenses2] = useState();
  const [dataExpenses3, _dataExpenses3] = useState();

  const [dataExpenseslist, _dataExpenseslist] = useState();

  const [xData, _xData] = useState({
    cmumis_id: "",
    name_thai: "",
    name_eng: "",
    short_name: "",
    start_date: "",
    end_date: "",
    receipt: ""
  });

  const [xid, _xid] = useState(1);

  const [xSumAmount, _xSumAmount] = useState(0);
  const [xSumAmount2, _xSumAmount2] = useState(0);
  const [xSumAmount3, _xSumAmount3] = useState(0);

  const [xSumAmount4, _xSumAmount4] = useState(0);
  const [xSumAmount5, _xSumAmount5] = useState(0);

  const [xSumAmount6, _xSumAmount6] = useState(0);
  const [xSumAmount7, _xSumAmount7] = useState(0);
  const [xSumAmount8, _xSumAmount8] = useState(0);
  const [xSumAmount9, _xSumAmount9] = useState(0);

  const [xSumAmount10, _xSumAmount10] = useState(0);
  const [xSumAmount11, _xSumAmount11] = useState(0);
  const [xSumAmount12, _xSumAmount12] = useState(0);

  const [xSumAmount13, _xSumAmount13] = useState(0);
  const [xSumAmount14, _xSumAmount14] = useState(0);
  const [xSumAmount15, _xSumAmount15] = useState(0);

  const [xSumAmount16, _xSumAmount16] = useState(0);
  const [xSumAmount17, _xSumAmount17] = useState(0);
  const [xSumAmount18, _xSumAmount18] = useState(0);

  const [xSumFee, _xSumFee] = useState(0);
  const [xSumOverH, _xSumOverH] = useState(0);

  const [xcrc, _xcrc] = useState("");
  const [xsummary, _xsummary] = useState(0);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [titlelist, _titlelist] = useState("");

  const [xidR, _xidR] = useState(1);

  const [xAmount1, _xAmount1] = useState(0);
  const [xAmount2, _xAmount2] = useState(0);
  const [xAmount3, _xAmount3] = useState(0);

  const xtname = localStorage.getItem("tname");

  useEffect(() => {
    const token = localStorage.getItem("token");

    var url = new URL(window.location.href);

    const user = localStorage.getItem("user");

    if (!user) {
      // ถ้าไม่มี user ให้ redirect ไปหน้า login
      window.location = "/login";
    } else {
      getData(url.searchParams.get("cmumis_id"));

      GetAgency(url.searchParams.get("cmumis_id"));
      GetInstallment1(url.searchParams.get("cmumis_id"));
      GetContract(url.searchParams.get("cmumis_id"));
      GetExpenses(url.searchParams.get("cmumis_id"));
      GetResearch(url.searchParams.get("cmumis_id"));

      getAmount(url.searchParams.get("cmumis_id"));
    }

    // axios
    //   .post(
    //     xURL + "authen",
    //     {},
    //     {
    //       headers: {
    //         Authorization: `Basic ${token}`
    //       }
    //     }
    //   )
    //   .then(result => {
    //     if (result.data.status === "ok") {
    //       getData(url.searchParams.get("cmumis_id"));

    //       GetAgency(url.searchParams.get("cmumis_id"));
    //       GetInstallment1(url.searchParams.get("cmumis_id"));
    //       GetContract(url.searchParams.get("cmumis_id"));
    //       GetExpenses(url.searchParams.get("cmumis_id"));
    //       GetResearch(url.searchParams.get("cmumis_id"));

    //       getAmount(url.searchParams.get("cmumis_id"));
    //     } else {
    //       //alert("authen failed");
    //       localStorage.removeItem("token");
    //       window.location = "/";
    //     }
    //   })
    //   .catch(function(error) {
    //     // handle error
    //     console.log("problem here", error);
    //   });
  }, []);

  const GetAgency = cmumis_id => {
    axios
      .post(xURL + "find_agency", {
        cmumis_id: cmumis_id
      })
      .then(result => {
        //console.log(result);
        const Tb1 = [];
        let xnum = 1,
          xsum = 0;

        result.data.forEach((i, idx) => {
          Tb1.push({
            key: idx,
            c1: "แหล่งทุนที่ " + parseInt(idx + 1),
            c2: i.agency,
            c3: "งบประมาณ",
            c4: (
              <Text style={{ fontWeight: "bold" }}>
                {i.budget.toLocaleString(undefined, {
                  minimumFractionDigits: 2
                })}
              </Text>
            ),
            c5: "บาท",
            agency_id: i.agency_id
          });

          if (i.budget !== "") {
            xsum = parseFloat(xsum) + parseFloat(i.budget);
            xnum = xnum + 1;
          }
        });

        Tb1.push({
          key: xnum - 1,
          c1: "",
          c2: "",
          c3: "รวมงบประมาณ",
          c4: (
            <Text style={{ fontWeight: "bold" }}>
              {xsum.toLocaleString(undefined, {
                minimumFractionDigits: 2
              })}
            </Text>
          ),
          c5: "บาท"
        });

        _xid(xnum + 1);

        //  console.log(Tb1);

        _dataSource1(Tb1);
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const GetInstallment1 = cmumis_id => {
    axios
      .post(xURL + "find_installment1", {
        cmumis_id: cmumis_id,
        order: 1
      })
      .then(result => {
        //console.log(result);
        const Tb1 = [],
          Tbex = [];

        let xsum = 0,
          xsum2 = 0,
          xsum3 = 0,
          xsum4 = 0;

        result.data.forEach((i, idx) => {
          let xmoney_bath = "",
            xdetail = "",
            xremark = "",
            xdate_warn = "",
            xdate_due = "",
            xdate_receive = "",
            xtotal_receive = "",
            xtransfer_fee = "",
            xoverhead = "",
            xinvoice_date = "";

          if (i.money_bath != null) {
            xmoney_bath = i.money_bath.toLocaleString(undefined, {
              minimumFractionDigits: 2
            });
          }

          if (i.total_receive != null) {
            xtotal_receive = i.total_receive.toLocaleString(undefined, {
              minimumFractionDigits: 2
            });
          }

          if (i.detail != null) {
            xdetail = i.detail;
          }

          if (i.remark != null) {
            xremark = i.remark;
          }

          if (i.tracking_date && i.tracking_date != "0000-00-00") {
            xdate_warn = dayjs(i.tracking_date).format("DD/MM/BBBB");
          }
          if (i.deadline_date && i.deadline_date != "0000-00-00") {
            xdate_due = dayjs(i.deadline_date).format("DD/MM/BBBB");
          }
          if (i.date_receive && i.date_receive != "0000-00-00") {
            xdate_receive = dayjs(i.date_receive).format("DD/MM/BBBB");
          }

          if (i.invoice_date && i.invoice_date !== "0000-00-00") {
            xinvoice_date = dayjs(i.invoice_date).format("DD/MM/BBBB");
          }

          let url_file = "",
            url_fileiv = "";

          if (i.file_transfer) {
            if (i.file_transfer !== "undefined") {
              url_file = `${xURL}file4/${i.file_transfer}`;
            } else {
              url_file = "";
            }
          }

          if (i.file_invoice) {
            if (i.file_invoice !== "undefined") {
              url_fileiv = `${xURL}file3/${i.file_invoice}`;
            } else {
              url_fileiv = "";
            }
          }

          if (i.transfer_fee != null) {
            xtransfer_fee = i.transfer_fee.toLocaleString(undefined, {
              minimumFractionDigits: 2
            });
          }

          if (i.overhead_bath != null) {
            xoverhead = i.overhead_bath.toLocaleString(undefined, {
              minimumFractionDigits: 2
            });
          }

          Tb1.push({
            key: idx,
            term: idx + 1,
            amount: xmoney_bath,
            detail: xdetail,
            remark: xremark,
            date_warn: xdate_warn,
            date_due: xdate_due,
            date_receive: xdate_receive,
            total_usd: i.total_usd,
            total_receive: xtotal_receive,
            linkfile: url_file,
            linkfile2: i.file_invoice,
            linkfileiv: url_fileiv,
            agency: i.agencyname,
            transfer_fee: xtransfer_fee,
            overhead: xoverhead,
            date_invoice: xinvoice_date
          });

          Tbex.push({
            term: idx + 1,
            amount: i.money_bath,
            detail: xdetail,
            date_receive: xdate_receive,
            total_receive: i.total_receive,
            transfer_fee: i.transfer_fee,
            overhead: i.overhead_bath,
            remark: xremark
          });

          xsum = xsum + parseFloat(i.money_bath);

          if (i.total_receive) {
            xsum2 = xsum2 + parseFloat(i.total_receive);
          }

          if (i.transfer_fee) {
            xsum3 = xsum3 + parseFloat(i.transfer_fee);
          }
          if (i.overhead_bath) {
            xsum4 = xsum4 + parseFloat(i.overhead_bath);
          }
        });

        _dataSource2(Tb1);
        _xSumAmount(xsum);
        _xSumAmount2(xsum2);
        _xSumAmount4(xsum3);
        _xSumAmount5(xsum4);

        _dataSourceEx1(Tbex);
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const GetContract = cmumis_id => {
    axios
      .post(xURL + "find_mod", {
        cmumis_id: cmumis_id
      })
      .then(result => {
        //console.log(result);
        const Tb1 = [];
        let xsum = 0,
          xname = "";

        result.data.forEach((i, idx) => {
          let xsdate = dayjs(i.start_date).format("DD/MM/BBBB");
          let xedate = dayjs(i.end_date).format("DD/MM/BBBB");

          let url_file = "",
            xbudget = "0";

          url_file = `${xURL}file2/${i.file}`;

          if (i.budget) {
            xbudget = i.budget.toLocaleString(undefined, {
              minimumFractionDigits: 2
            });

            xsum = xsum + i.budget;
          }

          Tb1.push({
            key: idx,
            num: idx + 1,
            grant_no: i.grant_number,
            po: i.po_number,
            Modification: i.mod_no,
            sdate: xsdate,
            edate: xedate,
            budget: xbudget,
            currency: i.currency_name,
            description: i.remark,
            linkfile: url_file
          });

          xname = i.currency_name;
        });

        _xcrc(xname);
        _xsummary(xsum.toLocaleString());
        _xSumAmount3(xsum);

        // _dataMod(Tb1);
        _dataContract(Tb1);
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const GetExpenses = cmumis_id => {
    axios
      .post(xURL + "getExpenses", {
        cmumis_id: cmumis_id
      })
      .then(result => {
        const Tb1 = [],
          Tb2 = [],
          Tb3 = [],
          Tbex = [];

        let xsum = 0,
          xsum_1 = 0,
          xsum_2 = 0,
          xsum_3 = 0,
          xsum2 = 0,
          xsum2_1 = 0,
          xsum2_2 = 0,
          xsum2_3 = 0,
          xcal = 0,
          xcal_1 = 0,
          xcal_2 = 0,
          xcal_3 = 0,
          xsumcal = 0,
          xsumcal_1 = 0,
          xsumcal_2 = 0,
          xsumcal_3 = 0;

        let xdate_request = "",
          xdate_approved = "",
          xstatus = "",
          url_file = "";

        let xnum1 = 1,
          xnum2 = 1,
          xnum3 = 1;

        result.data.forEach((i, idx) => {
          xdate_request = dayjs(i.date_request).format("DD/MM/BBBB");

          if (i.date_approved) {
            xdate_approved = dayjs(i.date_approved).format("DD/MM/BBBB");
          } else {
            xdate_approved = "";
          }
          if (i.status == 1) {
            xstatus = "ยังไม่ได้จ่าย";
          } else if (i.status == 2) {
            xstatus = "จ่ายแล้วบางส่วน";
          } else if (i.status == 3) {
            xstatus = "จ่ายเงินครบแล้ว";
          }

          if (i.request_file) {
            url_file = `${xURL}file8/${i.request_file}`;
          } else {
            url_file = "";
          }

          xcal = i.request_amount - i.expenses;

          if (i.user_position == "1") {
            xcal_1 = i.request_amount - i.expenses;

            Tb1.push({
              key: idx,
              num: parseInt(xnum1),
              head_title: i.request_descripetion,
              date_request: xdate_request,
              date_approved: xdate_approved,
              amount: i.request_amount.toLocaleString(undefined, {
                minimumFractionDigits: 2
              }),
              amount2: i.expenses.toLocaleString(undefined, {
                minimumFractionDigits: 2
              }),
              linkfile: url_file,
              // status: xstatus,
              request_id: i.request_id,
              calamount: xcal_1.toLocaleString(undefined, {
                minimumFractionDigits: 2
              }),
              user_key: i.create_at,
              date_key: i.create_time,
              position: i.user_position,
              reference: i.request_profin_id
            });

            xsum_1 = xsum_1 + parseFloat(i.request_amount);
            xsum2_1 = xsum2_1 + parseFloat(i.expenses);
            xsumcal_1 = xsumcal_1 + parseFloat(xcal_1);

            xnum1 = xnum1 + 1;
          } else if (i.user_position == "2") {
            xcal_2 = i.request_amount - i.expenses;

            Tb2.push({
              key: idx,
              num: parseInt(xnum2),
              head_title: i.request_descripetion,
              date_request: xdate_request,
              date_approved: xdate_approved,
              amount: i.request_amount.toLocaleString(undefined, {
                minimumFractionDigits: 2
              }),
              amount2: i.expenses.toLocaleString(undefined, {
                minimumFractionDigits: 2
              }),
              linkfile: url_file,
              // status: xstatus,
              request_id: i.request_id,
              calamount: xcal_2.toLocaleString(undefined, {
                minimumFractionDigits: 2
              }),
              user_key: i.create_at,
              date_key: i.create_time,
              position: i.user_position,
              reference: i.request_profin_id
            });

            xsum_2 = xsum_2 + parseFloat(i.request_amount);
            xsum2_2 = xsum2_2 + parseFloat(i.expenses);
            xsumcal_2 = xsumcal_2 + parseFloat(xcal_2);

            xnum2 = xnum2 + 1;
          } else if (i.user_position == "3") {
            xcal_3 = i.request_amount - i.expenses;

            Tb3.push({
              key: idx,
              num: parseInt(xnum3),
              head_title: i.request_descripetion,
              date_request: xdate_request,
              date_approved: xdate_approved,
              amount: i.request_amount.toLocaleString(undefined, {
                minimumFractionDigits: 2
              }),
              amount2: i.expenses.toLocaleString(undefined, {
                minimumFractionDigits: 2
              }),
              linkfile: url_file,
              // status: xstatus,
              request_id: i.request_id,
              calamount: xcal_3.toLocaleString(undefined, {
                minimumFractionDigits: 2
              }),
              user_key: i.create_at,
              date_key: i.create_time,
              position: i.user_position,
              reference: i.request_profin_id
            });

            xsum_3 = xsum_3 + parseFloat(i.request_amount);
            xsum2_3 = xsum2_3 + parseFloat(i.expenses);
            xsumcal_3 = xsumcal_3 + parseFloat(xcal_3);

            xnum3 = xnum3 + 1;
          }

          Tbex.push({
            num: parseInt(idx + 1),
            head_title: i.request_descripetion,
            date_request: xdate_request,
            // date_approved: xdate_approved,
            amount: i.request_amount.toLocaleString(undefined, {
              minimumFractionDigits: 2
            }),
            // amount2: i.expenses.toLocaleString(undefined, {
            //   minimumFractionDigits: 2
            // }),
            // calamount: xcal.toLocaleString(undefined, {
            //   minimumFractionDigits: 2
            // }),
            reference: i.request_profin_id
            // status: xstatus
          });

          xsum = xsum + parseFloat(i.request_amount);
          xsum2 = xsum2 + parseFloat(i.expenses);
          xsumcal = xsumcal + parseFloat(xcal);
        });

        _xSumAmount6(
          xsum.toLocaleString(undefined, {
            minimumFractionDigits: 2
          })
        );
        _xSumAmount7(
          xsum2.toLocaleString(undefined, {
            minimumFractionDigits: 2
          })
        );

        _xSumAmount9(
          xsumcal.toLocaleString(undefined, {
            minimumFractionDigits: 2
          })
        );

        _xSumAmount10(
          xsum_1.toLocaleString(undefined, {
            minimumFractionDigits: 2
          })
        );
        _xSumAmount11(
          xsum2_1.toLocaleString(undefined, {
            minimumFractionDigits: 2
          })
        );

        _xSumAmount12(
          xsumcal_1.toLocaleString(undefined, {
            minimumFractionDigits: 2
          })
        );

        _xSumAmount13(
          xsum_2.toLocaleString(undefined, {
            minimumFractionDigits: 2
          })
        );
        _xSumAmount14(
          xsum2_2.toLocaleString(undefined, {
            minimumFractionDigits: 2
          })
        );

        _xSumAmount15(
          xsumcal_2.toLocaleString(undefined, {
            minimumFractionDigits: 2
          })
        );

        _xSumAmount16(
          xsum_3.toLocaleString(undefined, {
            minimumFractionDigits: 2
          })
        );
        _xSumAmount17(
          xsum2_3.toLocaleString(undefined, {
            minimumFractionDigits: 2
          })
        );

        _xSumAmount18(
          xsumcal_3.toLocaleString(undefined, {
            minimumFractionDigits: 2
          })
        );

        _dataExpenses(Tb1);
        _dataExpenses2(Tb2);
        _dataExpenses3(Tb3);

        _dataSourceEx2(Tbex);
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const GetResearch = cmumis_id => {
    axios
      .post(xURL + "find_research2", {
        cmumis_id: cmumis_id
      })
      .then(result => {
        //console.log(result);
        const Tb1 = [];
        let xnum = 0;

        result.data.forEach((i, idx) => {
          Tb1.push({
            key: idx,
            c1: "นักวิจัยที่ " + parseInt(idx + 1),
            c2: i.researname,
            c3: i.researcher_p_position_name,
            re_staff_id: i.researcher_staff_id,
            re_p_id: i.researcher_position_id,
            re_pp_id: i.researcher_project_position_id
          });

          xnum = xnum + 1;
        });

        _xidR(xnum + 1);

        _dataSource3(Tb1);
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const getData = cmumis_id => {
    _xSumAmount(0);
    _xSumAmount2(0);
    _xSumAmount3(0);

    axios
      .post(xURL + "Findproject", {
        cmumis_id: cmumis_id
      })
      .then(result => {
        _xData(result.data[0]);
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const getAmount = cmumis_id => {
    axios
      .post(xURL + "Expenses_amount", {
        cmumis_id: cmumis_id
      })
      .then(result => {
        _xAmount1(
          result.data[0].money_receive.toLocaleString(undefined, {
            minimumFractionDigits: 2
          })
        );
        _xAmount2(
          (result.data[0].request_amount +
            result.data[0].transfer_fee +
            result.data[0].overhead_bath).toLocaleString(undefined, {
            minimumFractionDigits: 2
          })
        );
        _xAmount3(
          (result.data[0].money_receive -
            (result.data[0].request_amount +
              result.data[0].transfer_fee +
              result.data[0].overhead_bath)).toLocaleString(undefined, {
            minimumFractionDigits: 2
          })
        );
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const bAddExpenses = () => {
    window.open(
      "/Research_expenses_request?cmumis_id=" + xData.cmumis_id,
      "_blank"
    );
  };

  const bAddreceive = () => {
    let xcmumis_id = "",
      xname = "",
      xshortname = "",
      xresearch = "",
      xdate = "";

    xcmumis_id = xData.cmumis_id;

    if (xData.name_thai === "") {
      xname = xData.name_eng;
    } else {
      xname = xData.name_thai;
    }

    xshortname = xData.short_name;

    xresearch = dataSource3[0].c2;

    xdate =
      dayjs(xData.start_date).format("DD/MM/BBBB") +
      " - " +
      dayjs(xData.end_date).format("DD/MM/BBBB");

    window.open(
      "/Research_input_installment?cmumis_id=" +
        xcmumis_id +
        "&name=" +
        xname +
        "&shortname=" +
        xshortname +
        "&research=" +
        xresearch +
        "&date=" +
        xdate,
      "_blank"
    );

    //setIsModalVisible3(false);
  };

  // const showMoney = (term, amount, detail) => {
  //   window.open(
  //     "/Research_show_transfer?cmumis_id=" +
  //       xData.cmumis_id +
  //       "&term=" +
  //       term +
  //       "&amount=" +
  //       amount +
  //       "&detail=" +
  //       detail,
  //     "_blank"
  //   );
  // };

  const showlist = zdata => {
    // console.log(zdata.amount2);

    if (zdata.amount2 !== "0.00") {
      setIsModalVisible(true);
      _titlelist(zdata.head_title);

      axios
        .post(xURL + "getExpenses_list", {
          // title: zdata.head_title,
          request_id: zdata.request_id
        })
        .then(result => {
          const Tb1 = [];
          let xsum = 0;

          let xdate_approved = "",
            url_file = "";

          result.data.forEach((i, idx) => {
            xdate_approved = dayjs(i.date_approved).format("DD/MM/BBBB");

            if (i.file_expenses) {
              url_file = `${xURL}file8/${i.file_expenses}`;
            } else {
              url_file = "";
            }

            Tb1.push({
              key: idx,
              num: parseInt(idx + 1),
              expense_description: i.expense_description,
              date_approved: xdate_approved,
              amount: i.expenses.toLocaleString(undefined, {
                minimumFractionDigits: 2
              }),
              linkfile: url_file,
              remark: i.remark,
              file_name: i.file_expenses,
              user_key: i.create_at,
              date_key: i.create_time
            });

            xsum = xsum + parseFloat(i.expenses);
          });

          _xSumAmount8(
            xsum.toLocaleString(undefined, {
              minimumFractionDigits: 2
            })
          );

          _dataExpenseslist(Tb1);
        })
        .catch(function(error) {
          // handle error
          console.log("problem here", error);
        });
    } else {
      swal("ไม่มีข้อมูล!", "กรุณาเพิ่มค่าใช้จ่ายก่อน", "warning");
    }
  };

  const AddMoney = (term, amount, detail) => {
    let xdetail = detail.replace("#", "%23");

    window.open(
      "/Research_transfer?cmumis_id=" +
        xData.cmumis_id +
        "&term=" +
        term +
        "&amount=" +
        amount +
        "&detail=" +
        xdetail,
      "_blank"
    );
  };

  const showMoney = (term, amount, detail) => {
    window.open(
      "/Research_show_transfer?cmumis_id=" +
        xData.cmumis_id +
        "&term=" +
        term +
        "&amount=" +
        amount +
        "&detail=" +
        detail,
      "_blank"
    );
  };

  const bExcel = () => {
    let xdata = [],
      xtabtitle = "",
      xtabtitle2 = "",
      header = [];

    xtabtitle = "รายรับ";
    xtabtitle2 = "รหัส CMU MIS " + xData.cmumis_id;

    header.push(
      "งวดที่",
      "จำนวนเงิน invoice	",
      "รายละเอียด",
      "วันที่รับเงิน(ล่าสุด)",
      "เงินที่ได้รับ(ทั้งหมด)",
      "ค่าธรรมเนียมโอนเงิน",
      "ค่าบริหารโครงการ",
      "หมายเหตุ"
    );

    xdata.push([xtabtitle]);
    xdata.push([xtabtitle2]);
    xdata.push([""]);
    xdata.push(header);

    for (var row in dataSourceEx1) {
      const xx = [];
      for (var col in dataSourceEx1[row]) {
        xx.push(dataSourceEx1[row][col]);
      }

      xdata.push(xx);
    }

    xdata.push([
      "รวมทั้งหมด",
      xSumAmount,
      "",
      "รวมเงินที่ได้รับ",
      xSumAmount2,
      xSumAmount4,
      xSumAmount5
    ]);

    var wb = xlsx.utils.book_new(),
      ws = xlsx.utils.json_to_sheet(xdata, { skipHeader: true });

    xlsx.utils.book_append_sheet(wb, ws, "Sheet1");
    xlsx.writeFile(wb, "รายรับ [" + xData.cmumis_id + "].xlsx");
  };

  const bExcel2 = () => {
    let xdata = [],
      xtabtitle = "",
      xtabtitle2 = "",
      header = [];

    xtabtitle = "รายการขออนุมัติใช้เงิน";
    xtabtitle2 = "รหัส CMU MIS " + xData.cmumis_id;

    header.push(
      "ที่",
      "หัวข้อเรื่องที่ขออนุมัติค่าใช้จ่าย",
      "วันที่ขออนุมัติ",
      // "วันที่อนุมัติ",
      "จำนวนเงินที่ขออนุมัติ",
      // "จำนวนค่าใช้จ่ายที่จ่ายแล้ว",
      // "คงเหลือ",
      "เลข Reference"
    );

    xdata.push([xtabtitle]);
    xdata.push([xtabtitle2]);
    xdata.push([""]);
    xdata.push(header);

    for (var row in dataSourceEx2) {
      const xx = [];
      for (var col in dataSourceEx2[row]) {
        xx.push(dataSourceEx2[row][col]);
      }

      xdata.push(xx);
    }

    // xdata.push(["", "", "", "รวม", xSumAmount6, xSumAmount7, xSumAmount9]);
    xdata.push(["", "", "รวม", xSumAmount6]);

    var wb = xlsx.utils.book_new(),
      ws = xlsx.utils.json_to_sheet(xdata, { skipHeader: true });

    xlsx.utils.book_append_sheet(wb, ws, "Sheet1");
    xlsx.writeFile(wb, "รายการขออนุมัติใช้เงิน [" + xData.cmumis_id + "].xlsx");
  };

  const columns1 = [
    {
      title: "c1",
      dataIndex: "c1",
      key: "c1"
    },
    {
      title: "c2",
      dataIndex: "c2",
      key: "c2"
    },
    {
      title: "c3",
      dataIndex: "c3",
      key: "c3",
      render: (text, record) => __TBShowText(record.c3, 1, 0)
    },
    {
      title: "c4",
      dataIndex: "c4",
      key: "c4",
      render: (text, record) => __TBShowText(record.c4, 1, 0)
    },
    {
      title: "c5",
      dataIndex: "c5",
      key: "c5"
    }
  ];

  const columns2 = [
    {
      title: "งวดที่",
      dataIndex: "term",
      key: "term",
      align: "center"
    },
    {
      title: "จำนวนเงิน invoice",
      dataIndex: "amount",
      key: "amount",
      align: "center",

      render: (text, record) => __TBShowText(record.amount, 1, 0)
    },
    {
      title: "รายละเอียด",
      dataIndex: "detail",
      key: "detail",
      width: 450
      //align: "center",

      //render: (text, record) => __TBShowText(record.detail, 0, 1)
    },
    {
      title: "วันที่ invoice",
      dataIndex: "date_invoice",
      key: "date_invoice",
      align: "center",
      render: (text, record) => {
        const [dd, mm, yyyyBE] = record.date_invoice.split("/");
        const yyyy = parseInt(yyyyBE, 10) - 543; // แปลง พ.ศ. -> ค.ศ.

        const invDate = dayjs(`${yyyy}-${mm}-${dd}`, "YYYY-MM-DD");
        const daysDiff = dayjs().diff(invDate, "day");
        let color = "black";
        if (daysDiff >= 60) {
          color = "red";
        } else if (daysDiff >= 45) {
          color = "orange"; // หรือ "yellow" ก็ได้ แต่ text บนพื้นขาวจะอ่านยาก
        }

        return (
          <span style={{ color }}>
            {text}
          </span>
        );
      }
    },
    {
      title: "วันที่รับเงิน(ล่าสุด)",
      dataIndex: "date_receive",
      key: "date_receive",
      align: "center"
    },
    {
      title: "เงินที่ได้รับ(ทั้งหมด)",
      dataIndex: "total_receive",
      key: "total_receive",
      align: "center",
      render: (text, record) => __TBShowText(record.total_receive, 1, 0)
    },
    {
      title: "ค่าธรรมเนียมโอนเงิน",
      dataIndex: "transfer_fee",
      key: "transfer_fee",
      align: "center",
      render: (text, record) => __TBShowText(record.transfer_fee, 1, 0)
    },
    {
      title: "ค่าบริหารโครงการ",
      dataIndex: "overhead",
      key: "overhead",
      align: "center",
      render: (text, record) => __TBShowText(record.overhead, 1, 0)
    },
    {
      title: "Invoice",
      dataIndex: "tfileiv",
      key: "tfileiv",
      align: "center",
      width: 130,
      render(text, record, index) {
        if (record.linkfileiv) {
          return {
            children: (
              <a href={record.linkfileiv} target="_blank">
                <PaperClipOutlined /> ไฟล์แนบ
              </a>
            )
          };
        }
      }
    },
    {
      title: "ใบโอน",
      dataIndex: "tfile",
      key: "tfile",
      align: "center",
      width: 130,
      render(text, record, index) {
        if (record.linkfile) {
          return {
            children: (
              <a href={record.linkfile} target="_blank">
                <PaperClipOutlined /> ไฟล์แนบ
              </a>
            )
          };
        }
      }
    },
    {
      title: "สถานะเงินโอน",
      dataIndex: "status_money",
      key: "status_money",
      align: "center",
      render(text, record, index) {
        // if (record.linkfile && record.linkfile2) {
        // if (parseFloat(record.total_receive) > 0) {
        if (!record.total_receive) {
          return {
            children: (
              <Button
                ghost
                icon={<PlusOutlined />}
                type="primary"
                size="small"
                onClick={e => {
                  //console.log("corresponding email is :", record.c4);
                  AddMoney(record.term, record.amount, record.detail);
                }}
              >
                เพิ่ม/แก้ไขเงินโอน
              </Button>
            )
          };
        } else {
          return {
            children: (
              <a
                style={{ color: "tomato" }}
                onClick={e => {
                  showMoney(record.term, record.amount, record.detail);
                }}
              >
                <CheckOutlined /> รับเงินโอนแล้ว
              </a>
            )
          };
        }
      }
    },
    {
      title: "หมายเหตุ",
      dataIndex: "remark",
      key: "remark",
      width: 350
      //align: "center",

      //render: (text, record) => __TBShowText(record.remark, 0, 1)
    }
  ];

  const cContract = [
    {
      title: "ที่",
      dataIndex: "num",
      key: "num",
      align: "center",
      width: 40
    },
    {
      title: "เลขที่สัญญา / Grant No.",
      dataIndex: "grant_no",
      key: "grant_no",
      align: "center",
      width: 130
    },
    {
      title: "PO / Protocol No.",
      dataIndex: "po",
      key: "po",
      align: "center",
      width: 130
    },
    {
      title: "ฉบับที่ / Modification",
      dataIndex: "Modification",
      key: "Modification",
      align: "center",
      width: 110
    },
    {
      title: "วันที่เริ่มต้น",
      dataIndex: "sdate",
      key: "sdate",
      align: "center",
      width: 120
    },
    {
      title: "วันที่สิ้นสุด",
      dataIndex: "edate",
      key: "edate",
      align: "center",
      width: 120
    },
    {
      title: "งบประมาณ",
      dataIndex: "budget",
      key: "budget",
      align: "center",
      width: 150,
      render: (text, record) => __TBShowText(record.budget, 1, 0)
    },
    {
      title: "หน่วย",
      dataIndex: "currency",
      key: "currency",
      align: "center",
      width: 80
    },
    {
      title: "คำอธิบาย",
      dataIndex: "description",
      key: "description",
      ellipsis: true
    },
    {
      title: "ไฟล์สัญญา",
      dataIndex: "tfile",
      key: "tfile",
      align: "center",
      width: 130,
      render(text, record, index) {
        return {
          children: (
            <a href={record.linkfile} target="_blank">
              <PaperClipOutlined /> ไฟล์สัญญา
            </a>
          )
        };
      },
      fixed: "right"
    }
  ];

  const cExpenses = [
    {
      title: "ที่",
      dataIndex: "num",
      key: "num",
      align: "center",
      width: 40
    },
    {
      title: "หัวข้อเรื่องที่ขออนุมัติค่าใช้จ่าย",
      dataIndex: "head_title",
      key: "head_title",
      width: 400
    },
    {
      title: "วันที่ขออนุมัติ",
      dataIndex: "date_request",
      key: "date_request",
      align: "center",
      width: 120
    },
    // {
    //   title: "วันที่อนุมัติ",
    //   dataIndex: "date_approved",
    //   key: "date_approved",
    //   align: "center",
    //   width: 120
    // },
    {
      title: "จำนวนเงินที่ขออนุมัติ",
      dataIndex: "amount",
      key: "amount",
      align: "center",
      width: 150,
      render: (text, record) => __TBShowText(record.amount, 1, 0)
    },
    // {
    //   title: (
    //     <div style={{ textAlign: "center" }}>จำนวนค่าใช้จ่ายที่จ่ายแล้ว</div>
    //   ),
    //   dataIndex: "amount2",
    //   key: "amount2",
    //   width: 180,
    //   render: (text, record) =>
    //     <span
    //       style={{
    //         cursor: "pointer",
    //         color: "#1890ff",
    //         textAlign: "right",
    //         display: "block"
    //       }}
    //       onClick={() => {
    //         showlist(record);
    //         // console.log("Clicked", record);
    //       }}
    //     >
    //       {text}
    //     </span>
    // },
    // {
    //   title: "คงเหลือ",
    //   dataIndex: "calamount",
    //   key: "calamount",
    //   align: "center",
    //   width: 120,
    //   render: (text, record) => __TBShowText(record.calamount, 1, 0)
    // },
    {
      title: "ไฟล์ขออนุมัติ",
      dataIndex: "tfile",
      key: "tfile",
      align: "center",
      width: 130,
      render(text, record, index) {
        return {
          children: record.linkfile
            ? <a
                href={record.linkfile}
                target="_blank"
                rel="noopener noreferrer"
              >
                <PaperClipOutlined /> ไฟล์ขออนุมัติ
              </a>
            : null
        };
      }
    },
    // {
    //   title: "สถานะ",
    //   dataIndex: "status",
    //   key: "status",
    //   align: "center",
    //   width: 120
    // },
    {
      title: "ผู้บันทึกข้อมูล",
      dataIndex: "user_key",
      key: "user_key",
      align: "center",
      width: 150
    },
    {
      title: "วัน-เวลา บันทึกข้อมูล",
      dataIndex: "date_key",
      key: "date_key",
      align: "center",
      width: 150
    },
    {
      title: "เลข Reference",
      dataIndex: "reference",
      key: "reference",
      align: "center",
      width: 150
    }
  ];

  const cExpenses2 = [
    {
      title: "ที่",
      dataIndex: "num",
      key: "num",
      align: "center",
      width: 40
    },
    {
      title: "หัวข้อเรื่องที่ขออนุมัติค่าใช้จ่าย",
      dataIndex: "head_title",
      key: "head_title",
      width: 400
    },
    {
      title: "วันที่ขออนุมัติ",
      dataIndex: "date_request",
      key: "date_request",
      align: "center",
      width: 120
    },
    // {
    //   title: "วันที่อนุมัติ",
    //   dataIndex: "date_approved",
    //   key: "date_approved",
    //   align: "center",
    //   width: 120
    // },
    {
      title: "จำนวนเงินที่ขออนุมัติ",
      dataIndex: "amount",
      key: "amount",
      align: "center",
      width: 150,
      render: (text, record) => __TBShowText(record.amount, 1, 0)
    },
    // {
    //   title: (
    //     <div style={{ textAlign: "center" }}>จำนวนค่าใช้จ่ายที่จ่ายแล้ว</div>
    //   ),
    //   dataIndex: "amount2",
    //   key: "amount2",
    //   width: 180,
    //   render: (text, record) =>
    //     <span
    //       style={{
    //         cursor: "pointer",
    //         color: "#1890ff",
    //         textAlign: "right",
    //         display: "block"
    //       }}
    //       onClick={() => {
    //         showlist(record);
    //         // console.log("Clicked", record);
    //       }}
    //     >
    //       {text}
    //     </span>
    // },
    // {
    //   title: "คงเหลือ",
    //   dataIndex: "calamount",
    //   key: "calamount",
    //   align: "center",
    //   width: 120,
    //   render: (text, record) => __TBShowText(record.calamount, 1, 0)
    // },
    {
      title: "ไฟล์ขออนุมัติ",
      dataIndex: "tfile",
      key: "tfile",
      align: "center",
      width: 130,
      render(text, record, index) {
        return {
          children: record.linkfile
            ? <a
                href={record.linkfile}
                target="_blank"
                rel="noopener noreferrer"
              >
                <PaperClipOutlined /> ไฟล์ขออนุมัติ
              </a>
            : null
        };
      }
    },
    // {
    //   title: "สถานะ",
    //   dataIndex: "status",
    //   key: "status",
    //   align: "center",
    //   width: 120
    // },
    {
      title: "ผู้บันทึกข้อมูล",
      dataIndex: "user_key",
      key: "user_key",
      align: "center",
      width: 150
    },
    {
      title: "วัน-เวลา บันทึกข้อมูล",
      dataIndex: "date_key",
      key: "date_key",
      align: "center",
      width: 150
    },
    {
      title: "เลข Reference",
      dataIndex: "reference",
      key: "reference",
      align: "center",
      width: 150
    }
  ];

  const cExpenses3 = [
    {
      title: "ที่",
      dataIndex: "num",
      key: "num",
      align: "center",
      width: 40
    },
    {
      title: "หัวข้อเรื่องที่ขออนุมัติค่าใช้จ่าย",
      dataIndex: "head_title",
      key: "head_title",
      width: 400
    },
    // {
    //   title: "วันที่ขออนุมัติ",
    //   dataIndex: "date_request",
    //   key: "date_request",
    //   align: "center",
    //   width: 120
    // },
    {
      title: "วันที่อนุมัติ",
      dataIndex: "date_approved",
      key: "date_approved",
      align: "center",
      width: 120
    },
    {
      title: "จำนวนเงินที่ขออนุมัติ",
      dataIndex: "amount",
      key: "amount",
      align: "center",
      width: 150,
      render: (text, record) => __TBShowText(record.amount, 1, 0)
    },
    // {
    //   title: (
    //     <div style={{ textAlign: "center" }}>จำนวนค่าใช้จ่ายที่จ่ายแล้ว</div>
    //   ),
    //   dataIndex: "amount2",
    //   key: "amount2",
    //   width: 180,
    //   render: (text, record) =>
    //     <span
    //       style={{
    //         cursor: "pointer",
    //         color: "#1890ff",
    //         textAlign: "right",
    //         display: "block"
    //       }}
    //       onClick={() => {
    //         showlist(record);
    //         // console.log("Clicked", record);
    //       }}
    //     >
    //       {text}
    //     </span>
    // },
    // {
    //   title: "คงเหลือ",
    //   dataIndex: "calamount",
    //   key: "calamount",
    //   align: "center",
    //   width: 120,
    //   render: (text, record) => __TBShowText(record.calamount, 1, 0)
    // },
    {
      title: "ไฟล์ขออนุมัติ",
      dataIndex: "tfile",
      key: "tfile",
      align: "center",
      width: 130,
      render(text, record, index) {
        return {
          children: record.linkfile
            ? <a
                href={record.linkfile}
                target="_blank"
                rel="noopener noreferrer"
              >
                <PaperClipOutlined /> ไฟล์ขออนุมัติ
              </a>
            : null
        };
      }
    },
    // {
    //   title: "สถานะ",
    //   dataIndex: "status",
    //   key: "status",
    //   align: "center",
    //   width: 120
    // },
    {
      title: "ผู้บันทึกข้อมูล",
      dataIndex: "user_key",
      key: "user_key",
      align: "center",
      width: 150
    },
    {
      title: "วัน-เวลา บันทึกข้อมูล",
      dataIndex: "date_key",
      key: "date_key",
      align: "center",
      width: 150
    },
    {
      title: "เลข Reference",
      dataIndex: "reference",
      key: "reference",
      align: "center",
      width: 150
    }
  ];

  const cExpenseslist = [
    {
      title: "ที่",
      dataIndex: "num",
      key: "num",
      align: "center",
      width: 40
    },
    {
      title: "รายละเอียดค่าใช้จ่าย",
      dataIndex: "expense_description",
      key: "expense_description",
      width: 400
    },
    {
      title: "วันที่จ่ายเงิน",
      dataIndex: "date_approved",
      key: "date_approved",
      align: "center",
      width: 120
    },
    {
      title: "จำนวนเงินที่จ่ายจริง",
      dataIndex: "amount",
      key: "amount",
      align: "center",
      width: 150,
      render: (text, record) => __TBShowText(record.amount, 1, 0)
    },
    {
      title: "ไฟล์หลักฐานการจ่ายเงิน",
      dataIndex: "tfile",
      key: "tfile",
      align: "center",
      width: 150,
      render(text, record, index) {
        return {
          children: record.linkfile
            ? <a
                href={record.linkfile}
                target="_blank"
                rel="noopener noreferrer"
              >
                <PaperClipOutlined /> ไฟล์แนบ
              </a>
            : null
        };
      }
    },
    {
      title: "หมายเหตุ",
      dataIndex: "remark",
      key: "remark",
      width: 200
    },
    {
      title: "ผู้บันทึกข้อมูล",
      dataIndex: "user_key",
      key: "user_key",
      align: "center",
      width: 150
    },
    {
      title: "วัน-เวลา บันทึกข้อมูล",
      dataIndex: "date_key",
      key: "date_key",
      align: "center",
      width: 150
    }
  ];

  const columns3 = [
    {
      title: "c1",
      dataIndex: "c1",
      key: "c1"
    },
    {
      title: "c2",
      dataIndex: "c2",
      key: "c2"
    },
    {
      title: "c3",
      dataIndex: "c3",
      key: "c3"
    }
  ];

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  //formatttable (Rigth or Left)
  function __TBShowText(zData, zRigth, zLeft) {
    if (zRigth === 1 && zLeft === 0) {
      return (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Text>
            {zData}
          </Text>
        </div>
      );
    } else if (zRigth === 0 && zLeft === 1) {
      return (
        <div style={{ display: "flex" }}>
          <Text>
            {zData}
          </Text>
        </div>
      );
    }
  }

  return (
    <React.Fragment>
      <StyledForm />

      <Header_title_c
        tname={JSON.parse(localStorage.getItem("user"))}
        // tname={localStorage.getItem("tname")}
        // research_id={localStorage.getItem("research_id")}
      />

      <Content
        className="site-layout"
        style={{ padding: "0 20px", marginTop: 64 }}
      >
        <Row justify="center">
          <Col span={23}>
            <PageHeader
              className="site-page-header"
              title={
                <a
                  style={{
                    color: "black"
                  }}
                  onClick={() => {
                    window.close();
                  }}
                >
                  รายละเอียดโครงการวิจัย
                </a>
              }
              onBack={() => window.close()}
            />

            <Divider />

            <br />

            <Descriptions
              bordered
              size={"small"}
              labelStyle={{ justifyContent: "flex-end", minWidth: 200 }}
            >
              <Descriptions.Item label="รหัส CMU MIS" span={3}>
                {xData.cmumis_id}
              </Descriptions.Item>
              <Descriptions.Item label="ชื่อโครงการ: (ภาษาไทย)" span={3}>
                {xData.name_thai}
              </Descriptions.Item>
              <Descriptions.Item label="ชื่อโครงการ: (ภาษาอังกฤษ)" span={3}>
                <p>
                  {xData.name_eng}
                </p>
              </Descriptions.Item>
              <Descriptions.Item label="ชื่อย่อโครงการ:" span={3}>
                {xData.short_name}
              </Descriptions.Item>
              <Descriptions.Item label="ยุทธศาสตร์ของมหาวิทยาลัย" span={3}>
                {xData.pub_type_cmu_name} {xData.pub_type_short}
              </Descriptions.Item>
              <Descriptions.Item label="วันที่เริ่มต้นโครงการ" span={3}>
                {dayjs(xData.start_date).format("DD/MM/BBBB")}
              </Descriptions.Item>
              <Descriptions.Item label="วันที่สิ้นสุดโครงการ" span={3}>
                {dayjs(xData.end_date).format("DD/MM/BBBB")}
              </Descriptions.Item>
              <Descriptions.Item label="สถานะโครงการ" span={3}>
                {xData.status}
              </Descriptions.Item>
              <Descriptions.Item label="นำส่งใบเสร็จให้แหล่งทุน" span={3}>
                {xData.receipt}
              </Descriptions.Item>
            </Descriptions>

            <br />
            <br />

            <Card>
              <Divider orientation="left" style={{ borderColor: "#C2CFFF" }}>
                <Text style={{ fontWeight: "bold" }}>แหล่งทุน</Text>
              </Divider>
              {xid > 1
                ? <Table
                    scroll={{ x: "max-content" }}
                    dataSource={dataSource1}
                    columns={columns1}
                    size="small"
                    pagination={false}
                    showHeader={false}
                  />
                : <p>---ไม่มีข้อมูล---</p>}
              <Divider orientation="left" style={{ borderColor: "#C2CFFF" }}>
                <Text style={{ fontWeight: "bold" }}>ผู้ร่วมวิจัย</Text>
              </Divider>
              {dataSource3 != ""
                ? <Table
                    scroll={{ x: "max-content" }}
                    dataSource={dataSource3}
                    columns={columns3}
                    size="small"
                    pagination={false}
                    showHeader={false}
                  />
                : <p>---ไม่มีข้อมูล---</p>}
              <Divider orientation="left" style={{ borderColor: "#C2CFFF" }}>
                <Text style={{ fontWeight: "bold" }}>สัญญาโครงการวิจัย</Text>
              </Divider>
              {dataContract != ""
                ? <Table
                    bordered
                    scroll={{ x: "max-content" }}
                    dataSource={dataContract}
                    columns={cContract}
                    size="small"
                    // pagination={{
                    //   onChange: (zpage, zpageSize) => {
                    //     pageOnChange4(zpage, zpageSize);
                    //   },
                    //   current: pageTable4,
                    //   pageSize: pageSizeTable4
                    // }}
                    pagination={false}
                    summary={() =>
                      <Table.Summary fixed>
                        <Table.Summary.Row
                          style={{
                            textAlign: "right",
                            backgroundColor: "#b5f5ec"
                          }}
                        >
                          <Table.Summary.Cell />
                          <Table.Summary.Cell />
                          <Table.Summary.Cell />
                          <Table.Summary.Cell />
                          <Table.Summary.Cell />
                          <Table.Summary.Cell>รวมทั้งหมด</Table.Summary.Cell>
                          <Table.Summary.Cell>
                            {xSumAmount3.toLocaleString(undefined, {
                              minimumFractionDigits: 2
                            })}
                          </Table.Summary.Cell>
                          <Table.Summary.Cell />
                          <Table.Summary.Cell />
                          <Table.Summary.Cell />
                        </Table.Summary.Row>
                      </Table.Summary>}
                  />
                : <p>---ไม่มีข้อมูล---</p>}
              <Divider orientation="left" style={{ borderColor: "#C2CFFF" }}>
                <Text style={{ fontWeight: "bold" }}>รายรับ</Text>
              </Divider>
              <Button
                ghost
                type="success"
                onClick={bExcel}
                style={{ marginBottom: "10px", width: "120px" }}
              >
                <FileExcelOutlined /> Excel
              </Button>
              {xSumAmount !== 0
                ? <Table
                    bordered
                    scroll={{ x: "max-content" }}
                    dataSource={dataSource2}
                    columns={columns2}
                    size="small"
                    pagination={false}
                    summary={() =>
                      <Table.Summary fixed>
                        <Table.Summary.Row
                          style={{
                            textAlign: "right",
                            backgroundColor: "#b5f5ec"
                          }}
                        >
                          <Table.Summary.Cell>รวมทั้งหมด</Table.Summary.Cell>
                          <Table.Summary.Cell>
                            {xSumAmount.toLocaleString(undefined, {
                              minimumFractionDigits: 2
                            })}
                          </Table.Summary.Cell>
                          <Table.Summary.Cell />
                          <Table.Summary.Cell />
                          <Table.Summary.Cell>
                            รวมเงินที่ได้รับ
                          </Table.Summary.Cell>
                          <Table.Summary.Cell>
                            {xSumAmount2.toLocaleString(undefined, {
                              minimumFractionDigits: 2
                            })}
                          </Table.Summary.Cell>
                          <Table.Summary.Cell>
                            {xSumAmount4.toLocaleString(undefined, {
                              minimumFractionDigits: 2
                            })}
                          </Table.Summary.Cell>
                          <Table.Summary.Cell>
                            {xSumAmount5.toLocaleString(undefined, {
                              minimumFractionDigits: 2
                            })}
                          </Table.Summary.Cell>
                          <Table.Summary.Cell />
                          <Table.Summary.Cell />
                          <Table.Summary.Cell />

                          <Table.Summary.Cell />
                        </Table.Summary.Row>
                      </Table.Summary>}
                  />
                : <p>---ไม่มีข้อมูล---</p>}

              <p
                style={{
                  fontSize: "12px",
                  fontStyle: "italic",
                  marginTop: "8px"
                }}
              >
                หมายเหตุ วันที่ invoice{" "}
                <span style={{ color: "orange" }}>สีเหลือง</span> เกิน 45 วัน ,
                วันที่ invoice <span style={{ color: "red" }}>สีแดง</span> เกิน
                60 วัน
              </p>

              <Row>
                <Space>
                  <Button ghost type="primary" onClick={bAddreceive}>
                    <PlusOutlined />เพิ่ม/แก้ไข รายรับ
                  </Button>
                </Space>
              </Row>
              <Divider orientation="left" style={{ borderColor: "#C2CFFF" }}>
                <Text style={{ fontWeight: "bold" }}>
                  รายการขออนุมัติใช้เงิน
                </Text>
              </Divider>
              <Button
                ghost
                type="success"
                onClick={bExcel2}
                style={{ marginBottom: "10px", width: "120px" }}
              >
                <FileExcelOutlined /> Excel
              </Button>

              <Divider orientation="left" style={{ borderColor: "#ebeffdff" }}>
                <Text
                  style={{
                    fontWeight: "bold",
                    fontSize: "13px"
                  }}
                >
                  คลินิก
                </Text>
              </Divider>

              {dataExpenses != ""
                ? <Table
                    bordered
                    scroll={{ x: "max-content" }}
                    dataSource={dataExpenses}
                    columns={cExpenses}
                    size="small"
                    pagination={false}
                    summary={() =>
                      <Table.Summary fixed>
                        <Table.Summary.Row
                          style={{
                            textAlign: "right",
                            backgroundColor: "#b5f5ec"
                          }}
                        >
                          <Table.Summary.Cell />
                          <Table.Summary.Cell />
                          {/* <Table.Summary.Cell /> */}
                          <Table.Summary.Cell>รวม</Table.Summary.Cell>
                          <Table.Summary.Cell>
                            {xSumAmount10.toLocaleString()}
                          </Table.Summary.Cell>
                          {/* <Table.Summary.Cell>
                            {xSumAmount11.toLocaleString()}
                          </Table.Summary.Cell>
                          <Table.Summary.Cell>
                            {xSumAmount12.toLocaleString()}
                          </Table.Summary.Cell> */}
                          <Table.Summary.Cell />
                          <Table.Summary.Cell />
                          <Table.Summary.Cell />
                          <Table.Summary.Cell />
                        </Table.Summary.Row>
                      </Table.Summary>}
                  />
                : <p>---ไม่มีข้อมูล---</p>}

              <p
                style={{
                  fontWeight: "bold",
                  fontSize: "12px",
                  marginTop: "5px"
                }}
              >
                - หมายเหตุ:
                รายการอนุมัติค่าใช้จ่ายสามารถใส่ค่าใช้จ่ายได้หลายรายการ
              </p>

              <Divider orientation="left" style={{ borderColor: "#ebeffdff" }}>
                <Text
                  style={{
                    fontWeight: "bold",
                    fontSize: "13px"
                  }}
                >
                  พัสดุ
                </Text>
              </Divider>

              {dataExpenses2 != ""
                ? <Table
                    bordered
                    scroll={{ x: "max-content" }}
                    dataSource={dataExpenses2}
                    columns={cExpenses2}
                    size="small"
                    pagination={false}
                    summary={() =>
                      <Table.Summary fixed>
                        <Table.Summary.Row
                          style={{
                            textAlign: "right",
                            backgroundColor: "#b5f5ec"
                          }}
                        >
                          <Table.Summary.Cell />
                          <Table.Summary.Cell />
                          {/* <Table.Summary.Cell /> */}
                          <Table.Summary.Cell>รวม</Table.Summary.Cell>
                          <Table.Summary.Cell>
                            {xSumAmount13.toLocaleString()}
                          </Table.Summary.Cell>
                          {/* <Table.Summary.Cell>
                            {xSumAmount14.toLocaleString()}
                          </Table.Summary.Cell>
                          <Table.Summary.Cell>
                            {xSumAmount15.toLocaleString()}
                          </Table.Summary.Cell> */}
                          <Table.Summary.Cell />
                          <Table.Summary.Cell />
                          <Table.Summary.Cell />
                          <Table.Summary.Cell />
                        </Table.Summary.Row>
                      </Table.Summary>}
                  />
                : <p>---ไม่มีข้อมูล---</p>}

              <p
                style={{
                  fontWeight: "bold",
                  fontSize: "12px",
                  marginTop: "5px"
                }}
              >
                - หมายเหตุ:
                รายการอนุมัติค่าใช้จ่ายสามารถใส่ค่าใช้จ่ายได้หลายรายการ
              </p>

              <Divider orientation="left" style={{ borderColor: "#ebeffdff" }}>
                <Text
                  style={{
                    fontWeight: "bold",
                    fontSize: "13px"
                  }}
                >
                  การเงิน
                </Text>
              </Divider>

              {dataExpenses3 != ""
                ? <Table
                    bordered
                    scroll={{ x: "max-content" }}
                    dataSource={dataExpenses3}
                    columns={cExpenses3}
                    size="small"
                    pagination={false}
                    summary={() =>
                      <Table.Summary fixed>
                        <Table.Summary.Row
                          style={{
                            textAlign: "right",
                            backgroundColor: "#b5f5ec"
                          }}
                        >
                          <Table.Summary.Cell />
                          <Table.Summary.Cell />
                          {/* <Table.Summary.Cell /> */}
                          <Table.Summary.Cell>รวม</Table.Summary.Cell>
                          <Table.Summary.Cell>
                            {xSumAmount16.toLocaleString()}
                          </Table.Summary.Cell>
                          {/* <Table.Summary.Cell>
                            {xSumAmount17.toLocaleString()}
                          </Table.Summary.Cell>
                          <Table.Summary.Cell>
                            {xSumAmount18.toLocaleString()}
                          </Table.Summary.Cell> */}
                          <Table.Summary.Cell />
                          <Table.Summary.Cell />
                          <Table.Summary.Cell />
                          <Table.Summary.Cell />
                        </Table.Summary.Row>
                      </Table.Summary>}
                  />
                : <p>---ไม่มีข้อมูล---</p>}
              <p
                style={{
                  fontWeight: "bold",
                  fontSize: "12px",
                  marginTop: "5px"
                }}
              >
                - หมายเหตุ:
                รายการอนุมัติค่าใช้จ่ายสามารถใส่ค่าใช้จ่ายได้หลายรายการ
              </p>

              <Row>
                <Space>
                  <Button ghost type="primary" onClick={bAddExpenses}>
                    <PlusOutlined />เพิ่ม/แก้ไข รายการขออนุมัติใช้เงิน
                  </Button>
                </Space>
              </Row>
              <Divider orientation="left" style={{ borderColor: "#C2CFFF" }}>
                <Text style={{ fontWeight: "bold" }}>คงเหลือ</Text>
              </Divider>
              <Form {...layout1}>
                <b>
                  <Form.Item label="เงินรับทั้งหมด" name="txtamount1">
                    {xAmount1} บาท
                  </Form.Item>
                  <Form.Item label="หักค่าใช้จ่าย" name="txtamount2">
                    {xAmount2} บาท
                  </Form.Item>
                  <Form.Item label="ยอดเงินคงเหลือ" name="txtamount3">
                    {xAmount3} บาท
                  </Form.Item>
                </b>
              </Form>
            </Card>
          </Col>
        </Row>
      </Content>

      <Modal
        title={
          <Text style={{ fontWeight: "bold" }}>ค่าใช้จ่ายที่จ่ายแล้ว</Text>
        }
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        width={1400}
      >
        หัวข้อเรื่องที่ขออนุมัติค่าใช้จ่าย : {titlelist}
        <Divider />
        <Table
          bordered
          scroll={{ x: "max-content" }}
          dataSource={dataExpenseslist}
          columns={cExpenseslist}
          size="small"
          pagination={false}
          summary={() =>
            <Table.Summary fixed>
              <Table.Summary.Row
                style={{
                  textAlign: "right",
                  backgroundColor: "#b5f5ec"
                }}
              >
                <Table.Summary.Cell />
                <Table.Summary.Cell />
                <Table.Summary.Cell>รวม</Table.Summary.Cell>
                <Table.Summary.Cell>
                  {xSumAmount8.toLocaleString()}
                </Table.Summary.Cell>
                <Table.Summary.Cell />
                <Table.Summary.Cell />
                <Table.Summary.Cell />
                <Table.Summary.Cell />
              </Table.Summary.Row>
            </Table.Summary>}
        />
      </Modal>

      <div style={{ height: "100px" }} />

      <Footer_last />
      <BackTop />
    </React.Fragment>
  );
};

export default Research_coordinator_list;
